import Http from '../containers/App/Http';
import store from '../containers/App/store'
import {setAllUsers} from "../redux/actions/usersActions";

export default class Users{

    getUsers(queryPageIndex, queryPageSize){
        // FETCH THE Users
        const formData = new FormData();
        formData.append('queryPageIndex',queryPageIndex);
        formData.append('queryPageSize',queryPageSize);

        return Http.post("/u/getUsers",formData).then(async response => {
            if (response.data.status === 'failed')
                return response;

            await store.dispatch(setAllUsers(response.data.data));
            return response;
        });
    };

    createNewUser(formData){
        // formData.append('queryPageIndex',queryPageIndex);
        // formData.append('queryPageSize',queryPageSize);

        return Http.post("/u/createNewUser",formData).then(async response => {
            if (response.data.status === 'failed')
                return response;

            return response;
        });
    };

    updateUser(formData){
        // formData.append('queryPageIndex',queryPageIndex);
        // formData.append('queryPageSize',queryPageSize);

        return Http.post("/u/updateUser",formData).then(async response => {
            if (response.data.status === 'failed')
                return response;

            return response;
        });
    };

}